import { cloneDeep } from "@swiggy-private/js-utils";

import type { IToingPriceComparisonBEData } from "../components/price-comparison-halfcard/types";

const LOTTIE_LAYER_NAMES = {
    PREV_BILL_AMT: "OldPrice",
    CURRENT_BILL_AMT: "NewPrice",
    FREE_CASH_AMT: "CashbackAmount",
    DIFF_IN_AMT: "diff_in_amt",
    SAVING_AMT: "Savings_amount",
} as const;

const LOTTIE_LAYER = {
    WINNING: "Winning",
    TIE_WITH_SAVINGS: "Tie- with savings",
    LOST_STATE: "Lost state",
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isTextLayer = (layer: any) => layer.ty === 5;

const toRoundedString = (value: unknown): string | undefined => {
    const num = Number(value);
    return Number.isFinite(num) ? String(Math.round(num)) : undefined;
};

export function updateSuccessLottieData(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    lottieData: any,
    successData: IToingPriceComparisonBEData["success_state_halfcard_data"],
    totalSavings: number,
) {
    const updatedLottie = cloneDeep(lottieData);
    if (updatedLottie.nm === LOTTIE_LAYER.WINNING) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        updatedLottie.layers.forEach((layer: any) => {
            if (!isTextLayer(layer)) return;

            const layerName = layer.nm;
            const textValue = (() => {
                switch (layerName) {
                    case LOTTIE_LAYER_NAMES.PREV_BILL_AMT:
                        return toRoundedString(successData?.prev_bill_amt);
                    case LOTTIE_LAYER_NAMES.CURRENT_BILL_AMT:
                        return toRoundedString(successData?.current_bill_amt);
                    case LOTTIE_LAYER_NAMES.FREE_CASH_AMT:
                        return toRoundedString(successData?.free_cash_amt);
                    case LOTTIE_LAYER_NAMES.DIFF_IN_AMT:
                        return toRoundedString(successData?.diff_in_amt);
                    default:
                        return undefined;
                }
            })();
            if (textValue != null && layer.t?.d?.k?.[0]?.s?.t != null) {
                layer.t.d.k[0].s.t = textValue;
            }
        });
    }

    if (updatedLottie.nm === LOTTIE_LAYER.TIE_WITH_SAVINGS) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        updatedLottie.layers.forEach((layer: any) => {
            if (!isTextLayer(layer)) return;

            const layerName = layer.nm;
            const textValue = (() => {
                switch (layerName) {
                    case LOTTIE_LAYER_NAMES.SAVING_AMT:
                        return toRoundedString(totalSavings);
                }
            })();
            if (textValue != null && layer.t?.d?.k?.[0]?.s?.t != null) {
                layer.t.d.k[0].s.t = textValue;
            }
        });
    }

    if (updatedLottie.nm === LOTTIE_LAYER.LOST_STATE) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        updatedLottie.layers.forEach((layer: any) => {
            if (!isTextLayer(layer)) return;

            const layerName = layer.nm;
            const textValue = (() => {
                switch (layerName) {
                    case LOTTIE_LAYER_NAMES.SAVING_AMT:
                        return toRoundedString(successData?.diff_in_amt);
                }
            })();
            if (textValue != null && layer.t?.d?.k?.[0]?.s?.t != null) {
                layer.t.d.k[0].s.t = textValue;
            }
        });
    }

    return updatedLottie;
}
